module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"postReportButton.errorMessage":"There was an error encountered while creating this report. If everything looks right please contact support so we can help you :)","postReportButton.saveAndView":"Save and View"}}')
  delete Component.options._Ctor
}
